import axios from "axios";
import axiosConfig from "./axios-config/instance";

// GET call
export const getAPI = (endpoint: any, params?: any) => {
  return axiosConfig
    .get(endpoint, {
      params: params,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return axiosErrorHandler(error);
    });
};
//POST call
export const postAPI = (endpoint: any, postObj: any) => {
  return axiosConfig
    .post(endpoint, postObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return axiosErrorHandler(error);
    });
};
//PUT call
export const putAPI = (endpoint: any, postObj?: any) => {
  return axiosConfig
    .put(endpoint, postObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return axiosErrorHandler(error);
    });
};
//DELETE call
export const deleteAPI = (endpoint: any) => {
  return axiosConfig
    .delete(endpoint)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return axiosErrorHandler(error);
    });
};
//axios Error Handler
const axiosErrorHandler = (error: any) => {
  if (axios.isAxiosError(error)) {
    return error.message;
  } else {
    return "An unexpected error occurred";
  }
};
